<template>
  <!-- 未設定 AI 客服 → 維持預留 COMING_SOON placeholder；已設定 → 由 Chatwoot 原生泡泡呈現（此處不渲染，避免兩顆並存/擋到說明文字）-->
  <div v-if="!aiEnabled" class="ur-sel-chat-wrap">
    <div v-if="showHint" class="ur-sel-chat-hint" @click="showHint = false">
      {{ $t('URBANRENEWAL_SELECT.CHAT.COMING_SOON') }}
    </div>
    <button
      type="button"
      class="ur-sel-chat-fab"
      :title="$t('URBANRENEWAL_SELECT.CHAT.TITLE')"
      @click="showHint = true"
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
      </svg>
    </button>
  </div>
</template>
<script>
export default {
  name: 'UrbanRenewalSelectChatEntry',
  data() {
    return {
      showHint: false,
    };
  },
  computed: {
    aiSupport() {
      return this.$store.state.urbanRenewalSelect.aiSupport;
    },
    // 已啟用且有 websiteToken 才嵌入 Chatwoot
    aiEnabled() {
      const a = this.aiSupport;
      return !!(a && a.enabled && a.token);
    },
  },
  watch: {
    aiEnabled: {
      immediate: true,
      handler(v) {
        if (v) this.enableChatwoot();
      },
    },
  },
  beforeDestroy() {
    // 離開選配頁 → 隱藏泡泡（SDK 一旦載入會常駐 body，用 body class 控制只在本頁顯示）
    document.body.classList.remove('ur-ai-support-on');
  },
  methods: {
    enableChatwoot() {
      document.body.classList.add('ur-ai-support-on');
      if (window.__urChatwootLoaded) return;   // 避免重複注入 SDK
      window.__urChatwootLoaded = true;

      const a = this.aiSupport;
      const baseUrl = (a.url && a.url.trim()) || 'https://chat.upday.ai';
      const token = a.token;

      // 依 UpChat 提供之標準嵌入片段（url/token 為 per-tenant 參數）
      (function (d, t) {
        const g = d.createElement(t);
        const s = d.getElementsByTagName(t)[0];
        g.src = baseUrl + '/packs/js/sdk.js';
        g.defer = true;
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function () {
          if (window.chatwootSDK) {
            window.chatwootSDK.run({ websiteToken: token, baseUrl: baseUrl });
          }
        };
      })(document, 'script');
    },
  },
};
</script>
